export const APP_NAME = 'GlowPro';
export const APP_ICON_PATH = '/brand/icon.svg';
export const APP_WORDMARK_PATH = '/brand/wordmark.png';
